/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import dialerStoreData from "Stores/DialerData";
import DialerServiceData from "Stores/DialerServiceStore";
import { checkTeamSubscriptionActive } from "Utils/commonAPI";
import { ReactComponent as StarIcon } from "Assets/svg/star.svg";
import { ReactComponent as DeleteIcon } from "Assets/svg/bin.svg";
import YellowStarIcon from "Assets/png/yellowStar.png";
import userDetail from "Stores/userDetail";
import Utils from "Utils/utils";
import { withRouter } from "react-router-dom";
import { toasterState } from "Components/common/toaster";
import { makeApi, URLS } from "Utils/apiURL";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import { buyNewNumberPopupState } from "./BuyNewNumberPopup";
import { buyCreditsPopupState } from "./BuyCreditsPopup";
import { transactionAnimationState } from "Components/common/TransactionAnimation";
import twinklingStar from "Utils/LottieFiles/twinklingStar.json";
import Lottie from "react-lottie";
import { MP_EVENT } from "Static/constant";
import { addNumberPopupState } from "./AddNumberPopup";
import { addMyOwnNumberPopupState } from "./AddMyOwnNumberPopup";
import { verifyNumberPopupState } from "./VerifyNumberPopup";
import VoBizBuyNumberPopup, { voBizBuyNumberPopupState } from "./VoBizBuyNumberPopup";
import DialerUpgradePopup from "./DialerUpgradePopup";
import DialerLoadingCards from "./DialerLoadingCards";
import ToggleBtnType from "Components/common/ToggleBtnType";
import { upgradePopupState } from "Components/Paywall/UpgradePopup";
import CustomTooltip from "Components/common/CustomTooltip";
import LimitErr from "Components/PreviewPopup/LimitErr";
import Flags from "Assets/png/flags.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import countryData from "country-telephone-data";
import "react-telephone-input/css/default.css";

const Dialer = observer(props => {
  const history = useHistory();
  let isAdminUser = Utils.isAdmin();
  const {
    dialerEnabled = false,
    subscriptionPlanId = "",
    recordingEnabled = ""
  } = userDetail.userFeatureFlag || {};

  let callRecordingEnabled =
    dialerEnabled && dialerStoreData.callRecordingEnabled;

  const indiaCallingEnabled = userDetail.userFeatureFlag?.indiaCallingEnabled === true;

  const [loading, setLoading] = useState(true);
  const [myPhoneNumbers, setMyphoneNumbers] = useState([]);
  const [defaultNumber, setDefaultNumber] = useState("");
  const [voBizNumbers, setVoBizNumbers] = useState([]);
  const [voBizDefaultNumber, setVoBizDefaultNumber] = useState("");
  const [voBizLoading, setVoBizLoading] = useState(true);
  const [callRecording, setCallRecording] = useState(callRecordingEnabled);
  const [callRecordLoader, setCallRecordLoader] = useState(
    recordingEnabled === ""
  );

  const constructPhoneNumberDetails = data => {
    if (data?.defaultPhNumber && data?.phoneNumbers) {
      const { phoneNumbers, defaultPhNumber } = data;
      const numberWithDetails = addstarAttributeWithResponse(phoneNumbers);
      setMyphoneNumbers(numberWithDetails);
      setDefaultNumber(defaultPhNumber);
    } else {
      setMyphoneNumbers([]);
      setDefaultNumber("");
    }
    setLoading(false);
  };

  const addstarAttributeWithResponse = numbers => {
    if (numbers?.length) {
      const tempArr = [];
      numbers.map(phNumber => {
        const {
          number,
          numberType,
          nextRenewalDate = "",
          freePurchase = false
        } = phNumber;
        const tempObj = {
          starClicked: false,
          value: number,
          type: numberType,
          nextRenewalDate: nextRenewalDate,
          freePurchase
        };
        tempArr.push(tempObj);
      });
      return tempArr;
    }
  };

  const toggleStarFlag = number => {
    if (number) {
      myPhoneNumbers.map(obj => {
        if (obj?.value === number) {
          obj.starClicked = !obj.starClicked;
        }
      });
      setMyphoneNumbers(JSON.parse(JSON.stringify(myPhoneNumbers)));
    }
  };

  const renderPhoneNumbers = () => {
    return loading ? (
      <DialerLoadingCards cards={4} />
    ) : (
      <>
        <div className="numbersCard">
          <PhoneNumbersCard
            myPhoneNumbers={myPhoneNumbers}
            defaultNumber={defaultNumber}
            toggleStarFlag={toggleStarFlag}
            isAdminUser={isAdminUser}
          />
        </div>
      </>
    );
  };

  const renderVoBizNumbers = () => {
    return voBizLoading ? (
      <DialerLoadingCards cards={2} />
    ) : (
      <div className="numbersCard">
        <VoBizPhoneNumbersCard
          voBizNumbers={voBizNumbers}
          voBizDefaultNumber={voBizDefaultNumber}
          setVoBizDefaultNumber={setVoBizDefaultNumber}
          setVoBizNumbers={setVoBizNumbers}
        />
      </div>
    );
  };

  const renderCallCredits = () => {
    return loading ? (
      <DialerLoadingCards cards={1} />
    ) : (
      <>
        <div className="numbersCard">
          <CallCredits />
        </div>
      </>
    );
  };

  const getNumberAndCreditsForEnabledUser = () => {
    if (dialerEnabled) {
      dialerStoreData.checkAndCreateTwilioSubAccount();
      dialerStoreData.getMyPhoneNumbers();
      if (indiaCallingEnabled) {
        // Ensure VoBiz subaccount exists for this team (idempotent — safe to call every load)
        DialerServiceData.createVoBizSubAccount();
        DialerServiceData.getVoBizPhoneNumbers().finally(() =>
          setVoBizLoading(false)
        );
      } else {
        setVoBizLoading(false);
      }
    }
  };

  const handleRecordingChange = async value => {
    const { recordingEnabled = false, inFreePlan = false } =
      userDetail.userFeatureFlag || {};
    if (inFreePlan) {
      confirmationPopupState.setPopupValues({
        content: (
          <LimitErr
            headingContent={`Oops! you’re trying to record calls, but this feature isn’t available on your plan.`}
            limitMessage={`Please upgrade to one of our premium plan to add call credits and enable call recording.`}
          />
        ),
        dynamicDom: true,
        actionBtnText: "Okay",
        cancelBtnText: "Upgrade",
        cancelCbk: () => {
          confirmationPopupState.setShowPopup(false);
          history && history.push("/pricing");
        },
        callback: () => {
          confirmationPopupState.setShowPopup(false);
        }
      });
      confirmationPopupState.setShowPopup(true);
      return;
    }

    if (isAdminUser) {
      try {
        setCallRecordLoader(true);
        const config = {
          url: URLS.callRecordingSetting,
          method: "POST",
          data: { recordingEnabled: value }
        };
        const res = await makeApi(config);
        if (res?.data?.status === "success") {
          setCallRecording(value);
          userDetail.setUserFeatureFlag({
            ...userDetail.userFeatureFlag,
            recordingEnabled: value
          });
          toasterState.setToastMsg("Successfully Updated", "success");
        } else {
          setCallRecording(callRecording);
          toasterState.setToastMsg(
            "Something went wrong. Please try again later",
            "failure"
          );
        }
        setCallRecordLoader(false);
      } catch (e) {
        console.error("Call recording failed", e);
      }
    } else {
      contactAdminPopup();
    }
  };

  const contactAdminPopup = () => {
    let msg =
      "Please contact your account administrator to enable/disable your call recording";
    Utils.showMessagePopup(msg);
  };

  useEffect(() => {
    getNumberAndCreditsForEnabledUser();
    Utils.mixpanelTrack(MP_EVENT.DIALER_SETTINGS_VIEWED);
  }, []);

  useEffect(() => {
    !dialerStoreData?.myPhoneNumbers?.myPhoneNumbers &&
      constructPhoneNumberDetails(dialerStoreData.myPhoneNumbers);
  }, [dialerStoreData.myPhoneNumbers]);

  useEffect(() => {
    if (DialerServiceData.voBizPhoneList !== null) {
      setVoBizNumbers(DialerServiceData.voBizPhoneList || []);
      setVoBizDefaultNumber(DialerServiceData.voBizDefaultNo || "");
      setVoBizLoading(false);
    }
  }, [DialerServiceData.voBizPhoneList, DialerServiceData.voBizDefaultNo]);

  useEffect(() => {
    setCallRecording(dialerStoreData.callRecordingEnabled);
  }, [dialerStoreData.callRecordingEnabled]);


  return (
    <div className={`dialerWrapper`}>
      <div className="dialerInnercont">
        {dialerEnabled ? (
          <>
            <div className="numbersWrapper">
              <div className="dialerTitle">My Phone Numbers</div>
              {renderPhoneNumbers()}
            </div>
            {indiaCallingEnabled && (
              <div className="numbersWrapper" style={{ marginTop: "24px" }}>
                <div className="dialerTitle">India to India Calling</div>
                {renderVoBizNumbers()}
              </div>
            )}
            <div className="creditsWrapper">
              <div className="dialerTitle">Phone Call Credits</div>
              {renderCallCredits()}
            </div>
            <CallRecordings
              state={recordingEnabled}
              setCbk={handleRecordingChange}
              isAdminUser={isAdminUser}
              contactAdminCbk={contactAdminPopup}
              isLoading={callRecordLoader}
            />
          </>
        ) : (
          <DialerUpgradePopup {...props} />
        )}
      </div>
    </div>
  );
});

const PhoneNumbersCard = observer(props => {
  const {
    myPhoneNumbers = [],
    defaultNumber = "",
    toggleStarFlag = () => {},
    isAdminUser = true
  } = props || {};

  const purchaseCallBack = async (selectedPhoneNumber, key) => {
    if (key === "back") {
      showAddNumberOptions();
    } else {
      purchasePhoneNumber(selectedPhoneNumber);
    }
  };

  const purchaseCreditsCbk = async (amount = 0, stripeToken = "") => {
    if (amount && !stripeToken) {
      amount.setShowPopup(true);
      const payload = { amount };
      await dialerStoreData.purchaseCredits(payload);
      transactionAnimationState.setShowPopup(false);
    } else if (amount && stripeToken) {
      transactionAnimationState.setShowPopup(true);
      const payload = { chargeAmount: amount, stripeToken };
      await dialerStoreData.purchaseCreditsWithoutSubscription(payload);
      transactionAnimationState.setShowPopup(false);
    }
  };

  const buyCredits = async () => {
    if (await checkTeamSubscriptionActive()) {
      const cardResponse = Utils.checkCustomerIdAvailable();
      if (cardResponse === 200) {
        buyCreditsPopupState.setNewPayment(false);
        buyCreditsPopupState.setCallBack(purchaseCreditsCbk);
        buyCreditsPopupState.setPopupValue({ type: "DIALER" });
        buyCreditsPopupState.setShowPopup(true);
      } else if (Utils.isEligibleToShowPaymentPopup(cardResponse)) {
        buyCreditsPopupState.setNewPayment(true);
        buyCreditsPopupState.setCallBack(purchaseCreditsCbk);
        buyCreditsPopupState.setPopupValue({ type: "DIALER" });
        buyCreditsPopupState.setShowPopup(true);
      } else if (cardResponse === 203) {
        upgradePopupState.setPopupValues({
          type: "data_AddCreditsToDialer"
        });
        upgradePopupState.setPopup(true);
      }
    }
  };

  const purchasePhoneNumber = async (ph_number, token) => {
    transactionAnimationState.setShowPopup(true);
    const payload = { ph_number, token };
    await dialerStoreData.purchaseNumber(payload, buyCredits);
    transactionAnimationState.setShowPopup(false);
  };

  const ccPopupCbk = (phoneNumber, token, key) => {
    if (key === "back") {
      showAddNumberOptions();
    } else {
      purchasePhoneNumber(phoneNumber, token);
    }
  };

  const configureNumberCbk = (key, phNumber, extCode) => {
    if (key === "back") {
      showAddNumberOptions();
    } else if (key === "call") {
      verifyCall(phNumber, extCode);
    }
  };

  const buyNumberAction = () => {
    let msg = "";
    if (isAdminUser) {
      const { dialerEnabled = false } = userDetail?.userFeatureFlag || {};
      if (dialerEnabled) {
        buyNewNumberPopupState.setCallBack(purchaseCallBack);
        buyNewNumberPopupState.setShowPopup(true);
      } else {
        msg =
          "Access to buy new number is denied. Please contact your administrator";
        Utils.showMessagePopup(msg);
      }
    } else {
      msg =
        "Please contact your account administrator to change your call settings";
      Utils.showMessagePopup(msg);
    }
  };

  const configureNumberAction = e => {
    addMyOwnNumberPopupState.setCallBack(configureNumberCbk);
    addMyOwnNumberPopupState.setShowPopup(true);
  };

  const selectedNumberAction = key => {
    if (key) {
      if (key === "configureNumber") {
        configureNumberAction();
      } else if (key === "newNumber") {
        buyNumberAction();
      }
    }
  };

  const addNewNumberAction = async event => {
    if (await checkTeamSubscriptionActive()) {
      showAddNumberOptions(event);
    }
  };

  const showAddNumberOptions = e => {
    Utils.preventDefaultFn(e);
    addNumberPopupState.setCallback(selectedNumberAction);
    addNumberPopupState.setShowPopup(true);
  };

  const BuyNewNumberCard = () => {
    return (
      <div
        className="card newNumberCard"
        title="Click here to add"
        onClick={e => addNewNumberAction(e)}
      >
        <div className="phoneNumberCardheader">
          <div className="addNewNumber">+ Add a New Number</div>
        </div>
      </div>
    );
  };

  const updateDefaultNumber = async (e, number) => {
    Utils.preventDefaultFn(e);
    if (number) {
      toggleStarFlag(number);
      toasterState.setToastMsg("Updating...", "info");
      const payload = { ph_number: number };
      await dialerStoreData.updateDefaultPhoneNumber(payload);
      toggleStarFlag(number);
    }
  };

  const deletePhoneNumber = (e, number, type) => {
    Utils.preventDefaultFn(e);
    if (number) {
      if (Utils.isAdmin()) {
        const deleteCbk = async () => {
          toasterState.setToastMsg("Please Wait...", "info");
          confirmationPopupState.setShowPopup(true);
          const url = `${URLS.deletePhoneNumber}/${number}/${type}`;
          await dialerStoreData.deletePhoneNumber(url, number);
        };

        confirmationPopupState.setPopupValues({
          content: "Are you sure you want to delete this phone number?",
          actionBtnText: "Yes",
          callback: deleteCbk
        });
        confirmationPopupState.setShowPopup(true);
      } else {
        let msg =
          "Please contact your account administrator to change your call settings";
        Utils.showMessagePopup(msg);
      }
    }
  };

  const DefaultNumber = props => {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: twinklingStar,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };

    const { number = "", starClicked = false, type = "" } = props || {};
    let tempNumber = number?.replace("+", "");
    let tempDefaultNumber = defaultNumber?.replace("+", "");

    const isDefault = tempNumber === tempDefaultNumber;

    return (
      <div className="defaultNumber">
        <div
          className={`star icon ${isDefault ? "filled" : ""} ${
            starClicked ? "animatedStar" : ""
          }`}
          onClick={e => !isDefault && updateDefaultNumber(e, number)}
        >
          {isDefault ? (
            <img src={YellowStarIcon} alt="Default Number" />
          ) : !starClicked ? (
            <StarIcon />
          ) : (
            <Lottie
              options={defaultOptions}
              width={20}
              height={14}
              style={{ margin: "0 auto" }}
              speed={1.5}
            />
          )}
        </div>
        <div
          className="delete icon"
          onClick={e => deletePhoneNumber(e, number, type)}
        >
          <DeleteIcon />
        </div>
      </div>
    );
  };

  const constructVerifyUrl = (phNumber, extCode) => {
    return `${URLS.verifyMyPhNumber}/${phNumber}${
      phNumber && extCode?.length > 0 ? `?ext=${extCode}` : ""
    }`;
  };

  const verifyCall = async (phNumber, extCode) => {
    verifyNumberPopupState.setPhoneNumber(phNumber);
    verifyNumberPopupState.setShowPopup(true);
    const url = constructVerifyUrl(phNumber, extCode);
    const response = await dialerStoreData.verifyCallerId(url);
    if (response) {
      const { errorCode, code } = response;
      if (code) {
        verifyNumberPopupState.setCode(code);
      } else if (errorCode === 21450) {
        toasterState.setToastMsg(
          "Phone number already verified. Please use a different number",
          "failure"
        );
        verifyNumberPopupState.setShowPopup(false);
      } else {
        showError();
      }
    } else {
      showError();
    }
  };

  const showError = () => {
    verifyNumberPopupState.setShowPopup(false);
    toasterState.setToastMsg(
      "Something went wrong. Please try again later",
      "failure"
    );
  };

  const getRenewalText = date => {
    if (date) {
      const endDate = new Date(date);
      const currentDate = new Date();
      const diffTime = endDate - currentDate;
      const diffInDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffInDays > 0) {
        return `Renews in ${diffInDays} ${diffInDays > 1 ? "Days" : "Day"}`;
      } else {
        return `Renews today`;
      }
    }
  };

  const getCountryFromPhoneNumber = phoneNumber => {
    if (!phoneNumber) return null;

    const { allCountries, allCountryCodes, iso2Lookup } = countryData;
    const cleanNumber = phoneNumber.replace(/[^\d+]/g, "");
    const inputNumberForCountries = cleanNumber.replace(/^\+/, "").substr(0, 4);

    if (allCountryCodes[inputNumberForCountries]) {
      const iso2 = allCountryCodes[inputNumberForCountries][0];
      if (iso2 && iso2Lookup[iso2] !== undefined) {
        const country = allCountries[iso2Lookup[iso2]];
        if (country) return country;
      }
    }

    let bestMatch = { dialCode: "", priority: 10001 };

    allCountries.forEach(country => {
      const numberToCheck = cleanNumber.startsWith("+")
        ? cleanNumber.replace(/^\+/, "")
        : cleanNumber;
      const dialCodeToCheck = country.dialCode.replace(/^\+/, "");

      if (numberToCheck.startsWith(dialCodeToCheck)) {
        if (
          dialCodeToCheck.length > bestMatch.dialCode.replace(/^\+/, "").length
        ) {
          bestMatch = country;
        } else if (
          dialCodeToCheck.length ===
            bestMatch.dialCode.replace(/^\+/, "").length &&
          country.priority < bestMatch.priority
        ) {
          bestMatch = country;
        }
      }
    });

    if (!bestMatch || !bestMatch.name || bestMatch.priority === 10001) {
      return null;
    }

    return bestMatch;
  };

  const CountryFlag = ({ country }) => {
    if (!country || !country.iso2) return null;

    return (
      <div className="react-tel-input">
        <div
          className={`flag ${country.iso2.toLowerCase()}`}
          style={{ backgroundImage: `url(${Flags})` }}
        ></div>
      </div>
    );
  };

  return (
    <div className="cardWrapper">
      <BuyNewNumberCard />
      {myPhoneNumbers?.length > 0 &&
        myPhoneNumbers.map((obj, key) => {
          const {
            value = "",
            starClicked = false,
            type = "",
            nextRenewalDate = "",
            freePurchase = false
          } = obj;
          const countryInfo = getCountryFromPhoneNumber(value);
          return (
            <div className="card" id={value} key={`numberCard${key + value}`}>
              <div className="phoneNumberCardheader">
                <>
                  {freePurchase ? (
                    <div className="messageCont freeTextCont">
                      <div className="messageText">Free</div>
                    </div>
                  ) : nextRenewalDate ? (
                    <div className="messageCont">
                      <i className="fa fa-clock-o messageIcon"></i>
                      <div className="messageText">
                        {getRenewalText(nextRenewalDate)}
                      </div>
                    </div>
                  ) : (
                    <div
                      className="messageCont"
                      style={{ backgroundColor: "#d3ffc4" }}
                    >
                      <i className="fa fa-check-circle messageIcon"></i>
                      <div className="messageText">Verified number</div>
                    </div>
                  )}
                  <DefaultNumber
                    number={value}
                    starClicked={starClicked}
                    type={type}
                  />
                </>
              </div>
              <div className="otherDetails">
                <div className="country">
                  {countryInfo && (
                    <>
                      <CountryFlag country={countryInfo} />
                      <span className="countryName">{countryInfo.name}</span>
                    </>
                  )}
                </div>
                <div className="phoneNumber cardRow">
                  <span className="value phoneNumber">
                    {Utils.getFormattedPhoneNumber(value)}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
});

const VoBizPhoneNumbersCard = observer(props => {
  const {
    voBizNumbers = [],
    voBizDefaultNumber = "",
    setVoBizDefaultNumber = () => {},
    setVoBizNumbers = () => {}
  } = props;

  const [starClicking, setStarClicking] = useState(null);
  const isAdminUser = Utils.isAdmin();
  const teamId = userDetail?.userInfo?.team_id || userDetail?.userFeatureFlag?.id || "";

  const getCountryFromPhoneNumber = phoneNumber => {
    if (!phoneNumber) return null;
    const { allCountries, allCountryCodes, iso2Lookup } = countryData;
    const cleanNumber = phoneNumber.replace(/[^\d+]/g, "");
    const inputNumberForCountries = cleanNumber.replace(/^\+/, "").substr(0, 4);
    if (allCountryCodes[inputNumberForCountries]) {
      const iso2 = allCountryCodes[inputNumberForCountries][0];
      if (iso2 && iso2Lookup[iso2] !== undefined) {
        const country = allCountries[iso2Lookup[iso2]];
        if (country) return country;
      }
    }
    return null;
  };

  const CountryFlag = ({ country }) => {
    if (!country || !country.iso2) return null;
    return (
      <div className="react-tel-input">
        <div
          className={`flag ${country.iso2.toLowerCase()}`}
          style={{ backgroundImage: `url(${Flags})` }}
        ></div>
      </div>
    );
  };

  const updateVoBizDefault = async (e, number) => {
    Utils.preventDefaultFn(e);
    if (!number) return;
    setStarClicking(number);
    toasterState.setToastMsg("Updating...", "info");
    await DialerServiceData.updateVoBizDefaultPhoneNumber({ ph_number: number });
    setVoBizDefaultNumber(number);
    // Mark the number as configured in the local list
    setVoBizNumbers(prev =>
      prev.map(n => ({
        ...n,
        configured: n.number === number
      }))
    );
    setStarClicking(null);
  };

  const handleBuyNumber = () => {
    if (!isAdminUser) {
      Utils.showMessagePopup("Please contact your account administrator to purchase India numbers.");
      return;
    }
    voBizBuyNumberPopupState.setShowPopup(true);
  };

  const handleReleaseNumber = (e, numberStr) => {
    Utils.preventDefaultFn(e);
    if (!isAdminUser) {
      Utils.showMessagePopup("Please contact your account administrator to release India numbers.");
      return;
    }
    confirmationPopupState.setPopupValues({
      content: `Are you sure you want to release the India number ${numberStr}? This cannot be undone.`,
      actionBtnText: "Yes, Release",
      callback: async () => {
        toasterState.setToastMsg("Releasing number...", "info");
        confirmationPopupState.setShowPopup(false);
        await DialerServiceData.releaseIndiaNumber(numberStr);
      }
    });
    confirmationPopupState.setShowPopup(true);
  };

  // "Buy India Number" card — shown as the first card (mirrors BuyNewNumberCard for US)
  const BuyIndiaNumberCard = () => (
    <div
      className="card newNumberCard"
      title="Click to buy an India number"
      onClick={handleBuyNumber}
    >
      <div className="phoneNumberCardheader">
        <div className="addNewNumber">+ Buy India Number</div>
      </div>
    </div>
  );

  return (
    <>
      <div className="cardWrapper">
      <BuyIndiaNumberCard />
      {voBizNumbers.map((numObj, key) => {
        const numStr = numObj?.number || numObj;
        const countryInfo = getCountryFromPhoneNumber(numStr);
        const isDefault = numStr?.replace("+", "") === voBizDefaultNumber?.replace("+", "");
        const isClicking = starClicking === numStr;

        return (
          <div className="card" id={numStr} key={`voBizCard${key}${numStr}`}>
            <div className="phoneNumberCardheader">
              <div className="messageCont" style={{ backgroundColor: "#d3ffc4" }}>
                <i className="fa fa-check-circle messageIcon" style={{ color: "#22a06b" }}></i>
                <div className="messageText">Configured</div>
              </div>
              <div className="defaultNumber">
                <div
                  className={`star icon ${isDefault ? "filled" : ""} ${isClicking ? "animatedStar" : ""}`}
                  onClick={e => !isDefault && updateVoBizDefault(e, numStr)}
                  title={isDefault ? "Default number" : "Set as default to configure"}
                >
                  {isDefault ? (
                    <img src={YellowStarIcon} alt="Default Number" />
                  ) : (
                    <StarIcon />
                  )}
                </div>
                {/* Delete / release button */}
                <div
                  className="delete icon"
                  title="Release this number"
                  onClick={e => handleReleaseNumber(e, numStr)}
                >
                  <DeleteIcon />
                </div>
              </div>
            </div>
            <div className="otherDetails">
              <div className="country">
                {countryInfo && (
                  <>
                    <CountryFlag country={countryInfo} />
                    <span className="countryName">{countryInfo.name}</span>
                  </>
                )}
              </div>
              <div className="phoneNumber cardRow">
                <span className="value phoneNumber">
                  {Utils.getFormattedPhoneNumber(numStr)}
                </span>
              </div>
            </div>
          </div>
        );
      })}

    </div>
    </>
  );
});

const CallCredits = () => {
  const [credits, setCredits] = useState("");
  const [freeCalling, setFreeCalling] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const { inFreePlan = false, planName = "" } =
    userDetail?.userFeatureFlag || {};

  const purchaseCreditsCbk = async (selectedRechargeAmount, stripeToken) => {
    if (selectedRechargeAmount && !stripeToken) {
      transactionAnimationState.setShowPopup(true);
      const payload = { amount: selectedRechargeAmount };
      await dialerStoreData.purchaseCredits(payload);
      transactionAnimationState.setShowPopup(false);
    } else if (selectedRechargeAmount && stripeToken) {
      transactionAnimationState.setShowPopup(true);
      const payload = { chargeAmount: selectedRechargeAmount, stripeToken };
      await dialerStoreData.purchaseCreditsWithoutSubscription(payload);
      transactionAnimationState.setShowPopup(false);
    }
  };

  const buyCredits = async () => {
    if (inFreePlan) {
      upgradePopupState.setPopupValues({
        type: "dialer_addCredits"
      });
      upgradePopupState.setPopup(true);
    } else {
      if (await checkTeamSubscriptionActive()) {
        const cardResponse = Utils.checkCustomerIdAvailable();
        if (cardResponse === 200) {
          buyCreditsPopupState.setNewPayment(false);
          buyCreditsPopupState.setCallBack(purchaseCreditsCbk);
          buyCreditsPopupState.setPopupValue({ type: "DIALER" });
          buyCreditsPopupState.setShowPopup(true);
        } else if (Utils.isEligibleToShowPaymentPopup(cardResponse)) {
          buyCreditsPopupState.setNewPayment(true);
          buyCreditsPopupState.setCallBack(purchaseCreditsCbk);
          buyCreditsPopupState.setPopupValue({ type: "DIALER" });
          buyCreditsPopupState.setShowPopup(true);
        } else if (cardResponse === 203) {
          upgradePopupState.setPopupValues({
            type: "data_AddCreditsToDialer"
          });
          upgradePopupState.setPopup(true);
        }
      }
    }
  };

  useEffect(() => {
    setCredits(userDetail?.userFeatureFlag?.dialerCredits || 0.0);
  }, [userDetail.userFeatureFlag]);

  useEffect(() => {
    setFreeCalling(
      userDetail?.userFeatureFlag?.usFreeCallingMinutesEligible -
        userDetail?.userFeatureFlag?.usFreeCallingMinutesUsed || 0
    );
  }, [userDetail.userFeatureFlag]);

  return (
    <div className="card availableCredits">
      <div className="creditsCont">
        <div className="cardRow">Available</div>
        <div className="creditsData">
          $ {parseFloat(credits)?.toFixed(4) || "0.0"}
        </div>
        {freeCalling > 0 && (
          <div className="freecalling">
            <span className="freecallingText">{`Free US calling minutes remaining: ${freeCalling} min`}</span>
            <span
              className="freecallingIcon"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <i className="material-icons-outlined">info</i>
            </span>
            {showTooltip && (
              <CustomTooltip
                text={
                  inFreePlan
                    ? `Your plan includes 60 free calling minutes to US and Canada. And also includes 1 free calling US number.`
                    : `Your Basic/Pro/Enterprise plan includes 60 US calling minutes per month and 1 free US phone number.`
                }
              />
            )}
          </div>
        )}
      </div>
      <div
        className="actionBtns buyMoreText"
        onClick={e => buyCredits(e)}
        title="Click here to buy"
      >
        Add more credits
      </div>
    </div>
  );
};

const CallRecordings = props => {
  const {
    state = true,
    setCbk = () => {},
    isAdminUser = true,
    contactAdminCbk = () => {},
    isLoading = ""
  } = props || {};
  return (
    <div className="callRecordingWrapper">
      <div className="dialerTitle">Call Recording</div>
      <div className="callRecordingToggleBtn">
        <ToggleBtnType
          defaultValue={state}
          cbk={value => setCbk(value)}
          lastText="Automatically record all outgoing calls"
          isAllowed={isAdminUser}
          pageType="dialer"
          popupCbk={contactAdminCbk}
          enableLoading={isLoading}
        />
      </div>
      <div
        style={{
          paddingTop: "10px",
          color: "#878787",
          fontSize: "12px"
        }}
      >
        Please consult your legal counsel regarding the requirements for
        recording calls. Additional charges apply. Learn more about call
        recording charges{" "}
        <a
          target="_blank"
          style={{ textDecoration: "none", color: "#3953fb" }}
          rel="noopener noreferrer"
          href="https://support.salesgear.io/en/articles/6058343-dialer-call-credit-charges"
        >
          here.
        </a>
      </div>
    </div>
  );
};

export default withRouter(Dialer);
export { Dialer };
